const APP_TYPES = {
  afghan: 'afghanistan',
  standard: 'standard',
  retail: 'retail',
  basicBranch: 'basic_branch',
  premiumBranch: 'premium_branch',
  administrator: 'administrator',
  topupExchanger: 'topupexchanger',
  topupAdamin: 'topupadministrator',
  maknakAdmin: 'maknakadmin',
  ariyanaAdmin: 'ariyanaadmin',
  serviceProvider: 'serviceprovider',
  topsendAdmin: 'topsendadmin'
};

const generalCondition = (appType) => appType === APP_TYPES.administrator ||
  appType === APP_TYPES.afghan ||
  appType === APP_TYPES.standard ||
  appType === APP_TYPES.topupAdamin ||
  appType === APP_TYPES.topsendAdmin ||
  appType === APP_TYPES.maknakAdmin ||
  appType === APP_TYPES.ariyanaAdmin ||
  appType === APP_TYPES.basicBranch ||
  appType === APP_TYPES.premiumBranch;

const generalConditionExceptMaknak = (appType) => appType === APP_TYPES.administrator ||
  appType === APP_TYPES.afghan ||
  appType === APP_TYPES.standard ||
  appType === APP_TYPES.topupAdamin ||
  appType === APP_TYPES.topsendAdmin ||
  appType === APP_TYPES.ariyanaAdmin ||
  appType === APP_TYPES.basicBranch ||
  appType === APP_TYPES.premiumBranch;

// Individual permission functions based on role and appType
const permissionFunctions = {
  // Afghanistan-specific permissions
  IsAfghanVersion: (appType) => {
    if (appType === APP_TYPES.afghan) return true;
    return false;
  },

  AfghanBankLinks: (role, appType) => {
    if (role === 'admin') return true;
    if (appType === APP_TYPES.afghan || appType === APP_TYPES.administrator) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'cashierclerk',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  IsAdmin: (role, appType) => {
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    return false;
  },

  AfghanExcelPI: (role, appType) => {
    if (appType === APP_TYPES.afghan || appType === APP_TYPES.administrator) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'cashierclerk',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  // Archive Accounts
  ArchiveAccountsR: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  ArchivedAccountsA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Bank Account Permissions
  BankAccountsList: (role, appType) => {
    if (appType === APP_TYPES.retail) return true;
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'bankingclerk',
        'chequeemployee'
      ].includes(role);
    }
    return false;
  },

  // Bank Transaction Permissions
  BankTransactionRE: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'bankingclerk',
        'chequeemployee'
      ].includes(role);
    }
    return false;
  },

  // Bankbook
  BankbookA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'bankingclerk',
        'chequeemployee'
      ].includes(role);
    }
    return false;
  },

  BankBookD: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  BankBookRE: (role, appType) => {
    if (appType === APP_TYPES.retail) return true;
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3'
      ].includes(role);
    }
    return false;
  },

  // Branch Permissions
  BranchAccountA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  BranchAccountD: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  BranchAccountRE: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  BranchD: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  BranchFullAccess: (role, appType) => {
    if (appType === APP_TYPES.premiumBranch) {
      return true;
    }
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    return false;
  },

  BranchesA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  BranchR: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  BranchesListA: (role, appType) => {
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk'
      ].includes(role);
    }
    return false;
  },
  PaymentPlaceA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Cash Transaction Permissions
  CashTransactionRE: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'cashierclerk'
      ].includes(role);
    }
    return false;
  },

  // Checkouts
  CheckoutsD: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // Commission Reports
  CommissionReportsA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Employee Permissions
  CreateDeputyEmployee: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager'].includes(role);
    }
    return false;
  },

  // Currency Management
  CurrencyManagementA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },
  ExpireRateA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Currency Permissions
  CurrencyManagementList: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Customer Permissions
  CustomerD: (role, appType) => {
    if (appType === 'retail') {
      return ['manager'].includes(role);
    }
    if (appType === APP_TYPES.maknakAdmin) {
      return ['admin', 'supportlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  customerR: (role) => {
    if (role === 'chequeemployee') return false;
    return true;
  },

  CustomerE: (role, appType) => {
    if (appType === 'retail') {
      return ['manager'].includes(role);
    }
    if (appType === APP_TYPES.maknakAdmin) {
      return ['admin', 'supportlevel1'].includes(role);
    }
    if (generalConditionExceptMaknak(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk'
      ].includes(role);
    }
    return false;
  },

  // Comapany Permissions
  CompanyD: (role, appType) => {
    if (appType === 'retail') {
      return ['manager'].includes(role);
    }
    if (appType === APP_TYPES.maknakAdmin) {
      return ['admin', 'supportlevel1'].includes(role);
    }
    if (generalConditionExceptMaknak(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  CompanyE: (role, appType) => {
    if (appType === 'retail') {
      return ['manager'].includes(role);
    }
    if (appType === APP_TYPES.maknakAdmin) {
      return ['admin', 'supportlevel1'].includes(role);
    }
    if (generalConditionExceptMaknak(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3'
      ].includes(role);
    }
    return false;
  },

  CustomerRwithLimitation: (role, appType) => {
    if (appType === APP_TYPES.afghan) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'cashierclerk',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  CustomersListA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'cashierclerk',
        'bankingclerk',
        'chequeemployee'
      ].includes(role);
    }
    return false;
  },

  ReceiversListA: (role, appType) => {
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk'
      ].includes(role);
    }
    return false;
  },

  // Day Operations
  DayOperation: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3'
      ].includes(role);
    }
    return false;
  },

  // Debtor Creditor
  DebtorCreditorA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  DebtorCreditorRemainingTime: (role, appType) => {
    if (appType === APP_TYPES.afghan || appType === APP_TYPES.administrator) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk',
        'cashierclerk',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  // Draft Permissions
  DraftDocumentsListA: (role, appType) => {
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk'
      ].includes(role);
    }
    return false;
  },

  DraftExecutionR: (role, appType) => {
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk'
      ].includes(role);
    }
    return false;
  },

  DraftRE: (role, appType) => {
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'remittanceclerk'
      ].includes(role);
    }
    return false;
  },

  ShowExecuteDraftReceipt: (role) => ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(role),

  // Employee Permissions
  EmployeeE: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  EmployeeR: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // Excel Permissions
  ExcelPI: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  // Financial Operations
  FinancialOperationsA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return false;
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Hide Account Permissions
  HideAccountA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  HidenAccountA: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  HidenAccountR: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  // Increase Decrease Customer Credit
  IncreaseCustomerCredit: (role, appType) => {
    if (appType === APP_TYPES.administrator) {
      return [
        'admin'
      ].includes(role);
    }

    return false;
  },

  DecreaseCustomerCredit: (role, appType) => {
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);

    return false;
  },

  // wallet
  ExchangersCreditAccountA: (role, appType) => {
    if (appType === APP_TYPES.administrator) return !['admin'].includes(role);
    if (appType === APP_TYPES.maknakAdmin) {
      return [
        'admin',
        'supportlevel1'
      ].includes(role);
    }
    return true;
  },

  // customer credit account حساب اعتبارات
  SupportCreditCustomer: (role, appType) => {
    if (appType === APP_TYPES.maknakAdmin) {
      return ['admin', 'salesspecialist'].includes(role);
    }
    if (appType === APP_TYPES.ariyanaAdmin || appType === APP_TYPES.administrator) return ['admin'].includes(role);

    return false;
  },

  // Initial Credit
  InitialCreditR: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // Interbank Transactions
  InterbankTransactionRE: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  // Manage Organization Groups
  ManageOrganizationGroupsA: (role, appType) => {
    if (
      appType === APP_TYPES.afghan ||
      appType === APP_TYPES.basicBranch ||
      appType === APP_TYPES.premiumBranch
    ) {
      return true;
    }

    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    return false;
  },

  // Employee Permissions
  ManagerEmployeeR: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager'].includes(role);
    }
    return false;
  },

  // Organization Chart
  OrganizationChartA: (role, appType) => {
    if (APP_TYPES.afghan) return true;
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    return false;
  },

  OrganizationChartE: (role, appType) => {
    if (appType === APP_TYPES.afghan || appType === APP_TYPES.administrator) {
      return ['admin', 'manager', 'deputy'].includes(role);
    }
    return false;
  },

  // Payment Order
  PaymentOrderA: (role, appType) => {
    if (appType === APP_TYPES.administrator) {
      return ['admin'].includes(role);
    }
    return false;
  },

  // Pending Drafts
  PendingDraftsList: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  // Private Transactions
  PrivateTransactionR: (role, appType) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // Profit and Loss
  ProfitAndLossStatement: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // Register Account Groups
  RegisterAccountGroups: (role, appType) => {
    if (appType === APP_TYPES.afghan) return true;
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    return false;
  },

  // RePrint Receipt
  RePrintReceipt: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'cashierclerk',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  // Suggested Groups In Settings
  SuggestedGroupsInSettings: (role, appType) => {
    if (appType === APP_TYPES.afghan) {
      return true;
    }

    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);

    return false;
  },

  // System Accounts
  SystemAccountsD: (role, appType) => {
    if (appType === 'retail') return ['manager', 'deputy'].includes(role);

    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  SystemAccountsList: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'cashierclerk'
      ].includes(role);
    }
    return false;
  },

  SystemAccountsA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'cashierclerk',
        'chequeemployee'
      ].includes(role);
    }
    return false;
  },

  SystemAccountsRE: (role, appType) => {
    if (appType === 'retail') return ['manager', 'deputy'].includes(role);
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // System Settings
  SystemSettingsA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  SystemSettingItemA: (appType) => ![APP_TYPES.topupExchanger, APP_TYPES.serviceProvider].includes(appType),

  // Trade Currency
  TradeCurrencyA: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return ['admin', 'manager', 'deputy', 'managerlevel1', 'managerlevel2'].includes(
        role
      );
    }
    return false;
  },

  TradeCurrencyRE: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return ['manager', 'deputy', 'managerlevel1'].includes(role);
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'cashierclerk'
      ].includes(role);
    }
    return false;
  },

  // Transaction Group And Money Purpose
  TransactionGroupAndMoneyPurpose: (role, appType) => {
    if (appType === APP_TYPES.afghan) {
      return true;
    }
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    return false;
  },

  // Transfer Between Accounts
  TransferBetweenAccountsRE: (role, appType) => {
    if (appType === APP_TYPES.retail) {
      return true;
    }
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'cashierclerk'
      ].includes(role);
    }
    return false;
  },

  // Unknown Bank Transactions
  UnknownBankTransactionsA: (role, appType) => {
    if (generalCondition(appType)) {
      return [
        'admin',
        'manager',
        'deputy',
        'managerlevel1',
        'managerlevel2',
        'managerlevel3',
        'bankingclerk'
      ].includes(role);
    }
    return false;
  },

  // Special Permissions
  WhatsappA: (claims) => {
    const { role, app_type: appType, 'w.a': hasWhatsapp } = claims;
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    if (
      // access to whatsapp for all roles in afghan and standard versions if w.a claim is set to '1'
      (appType === APP_TYPES.afghan ||
        appType === APP_TYPES.standard ||
        appType === APP_TYPES.topupAdamin ||
        appType === APP_TYPES.topsendAdmin ||
        appType === APP_TYPES.maknakAdmin ||
      appType === APP_TYPES.ariyanaAdmin ||
        appType === APP_TYPES.premiumBranch) &&
      hasWhatsapp === '1'
    ) {
      return true;
    }
    return false;
  },

  WhatsappConnectionR: (claims) => {
    const { role, app_type: appType, 'w.a': hasWhatsapp } = claims;
    if (appType === APP_TYPES.administrator) return ['admin'].includes(role);
    if (
      (appType === APP_TYPES.afghan ||
        appType === APP_TYPES.standard ||
        appType === APP_TYPES.topupAdamin ||
        appType === APP_TYPES.topsendAdmin ||
        appType === APP_TYPES.maknakAdmin ||
      appType === APP_TYPES.ariyanaAdmin ||
        appType === APP_TYPES.premiumBranch) &&
      hasWhatsapp === '1'
    ) {
      return ['admin', 'manager', 'deputy', 'managerlevel1'].includes(role);
    }
    return false;
  },

  // cheques permissions
  ChequesListA: (_role, appType) => ![
    APP_TYPES.retail,
    APP_TYPES.topupExchanger,
    APP_TYPES.serviceProvider
    ].includes(appType),

  IsBasicBranch: (appType) => {
    if (appType === APP_TYPES.basicBranch) {
      return true;
    }
    return false;
  },

  settlementA: (appType) => [APP_TYPES.standard, APP_TYPES.afghan, APP_TYPES.retail].includes(appType),

  notesA: (appType) => ![APP_TYPES.topupExchanger, APP_TYPES.serviceProvider].includes(appType),

  AdvancedSearch: (appType) => ![APP_TYPES.topupExchanger, APP_TYPES.serviceProvider].includes(appType),

  dayOperationApproval: (appType, role) => {
    if (generalCondition(appType)) {
      return ['admin', 'manager'].includes(role);
    }
    return false;
  },
  OrganizationListA: (appType, role) => {
    if (appType === APP_TYPES.maknakAdmin) {
      return ['admin'].includes(role);
    }
    return false;
  },

  PaymentDetailsA: (appType, role) => {
    if ([APP_TYPES.administrator, APP_TYPES.maknakAdmin, APP_TYPES.ariyanaAdmin].includes(appType)) {
      return ['admin'].includes(role);
    }
    return false;
  }
};

export default permissionFunctions;
